<template>
    <form @submit.prevent="proceed" @keydown="lgaForm.errors.clear($event.target.name)">
        <div class="row">
            <div class="col-12 col-sm-12">
                <div class="form-group">
                    <label for="">Name</label>
                    <input class="form-control" :class="{ 'is-invalid': lgaForm.errors.has('name') }" type="text" value="" v-model="lgaForm.name" name="name" placeholder="Name">
                    <show-error :form-name="lgaForm" prop-name="name"></show-error>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right">
            <span v-if="id">{{trans('general.update')}}</span>
            <span v-else>{{trans('general.save')}}</span>
        </button>
        <router-link to="/lga" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" v-show="id">{{trans('general.cancel')}}</router-link>
        <button v-if="!id" type="button" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1" @click="$emit('cancel')">{{trans('general.cancel')}}</button>
    </form>
</template>


<script>
    export default {
        data() {
            return {
                lgaForm: new Form({
                    name : ''
                })
            };
        },
        props: ['id'],
        mounted() {
            if(this.id)
                this.getState();
        },
        methods: {
            proceed(){
                if(this.id)
                    this.updateState();
                else
                    this.storeState();
            },
            storeState(){
                this.lgaForm.post('/api/setting/lga')
                    .then(response => {
                        toastr.success(response.message);
                        this.$emit('completed')
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getState(){
                axios.get('/api/setting/lga/'+this.id)
                    .then(response => response.data)
                    .then(response => {
                        this.lgaForm.name = response.name;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                        this.$router.push('/setting/lga');
                    });
            },
            updateState(){
                this.lgaForm.patch('/api/setting/lga/'+this.id)
                    .then(response => {
                        toastr.success(response.message);
                        this.$router.push('/setting/lga');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
